export default function ColorChip({ color }) {
    return <div style={{background: color, width: "3rem", height: "1.75rem", borderRadius: "0.25rem", border: "1px solid #555"}} />;
}